import { takeLatest, call, put } from 'redux-saga/effects'
import lessonBlocksList from 'api/administration/blocks/List'
import { editSurveyBlockDetails } from 'api/administration/blocks/Edit'
import I18n from 'i18n'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'
import * as fromActions from '../../../actions/blocks.action'

async function getList(lessonId: number) {
  return await lessonBlocksList(lessonId)
}
async function editBlockSurvey(blockId: number, blockDetails: any) {
  return await editSurveyBlockDetails(blockId, blockDetails)
}

function* editBlockSurveyEffectSaga(action: any) {
  try {
    const { payload } = action

    const blockDetails = {
      block_survey: {
        send_email: false,
      },
      block_instance: {
        name: payload.name,
        description: payload.description,
        mandatory: payload.mandatory,
      },
    }

    yield call(editBlockSurvey, payload.id, blockDetails)
    const data = yield call(getList, payload.lessonId)
    yield put(fromActions.Actions.getLessonBlocksListSuccess(data))
    SuccessToast(I18n.t('administration.toastMessages.editSuccess'))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.editError'))
    console.log('error: ', error)
  }
}

export function* editBlockSurveyWatcherSaga() {
  yield takeLatest(
    fromActions.EDIT_SURVEY_BLOCK_DETAILS,
    editBlockSurveyEffectSaga
  )
}
